export default "__VITE_ASSET__CKbYwcbh__"